import classNames from 'classnames';
import { CSSProperties } from 'react';
import { Size } from '../../types';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import { IconProps } from '../Icon';
import IconRenderer, { IconDefinition } from '../IconRenderer';
import styles from './styles/IconTile.module.scss';

export type IconTilePresetVariant = 'neutral' | 'success' | 'error' | 'caution' | 'info';
export type IconTileCustomVariant = Pick<CSSProperties, 'background' | 'color'>;
export type IconTileSize = Size<'sm' | 'md' | 'lg'>;

export type IconTileProps = {
  className?: string;
  emphasis?: 'base' | 'weak' | 'strong';
  icon: IconDefinition<never>;
  radius?: 'squircle' | 'circle' | 'none';
  size?: IconTileSize;
  variant?: IconTilePresetVariant | IconTileCustomVariant;
};

const iconSizeBySize: Record<IconTileSize, IconProps['size']> = {
  sm: 'sm',
  md: 'sm',
  lg: 'md'
};

// https://www.figma.com/design/8FdZNb0ketbIxsbvem7jJn/Denali-Web-%E2%9D%96-Design-System?node-id=2378-2685
const IconTile = ({ className, emphasis = 'base', icon, radius = 'squircle', size = 'md', variant = 'neutral' }: IconTileProps) => {
  const isCustomVariant = typeof variant === 'object';

  return (
    <span
      {...setDenaliAttribute('IconTile')}
      className={classNames(
        styles.container,
        styles[size],
        styles[radius],
        isCustomVariant ? undefined : styles[variant],
        styles[emphasis],
        className
      )}
      style={
        isCustomVariant
          ? {
              background: emphasis !== 'weak' ? variant.background : undefined,
              color: variant.color
            }
          : undefined
      }
    >
      <IconRenderer icon={icon} defaults={{ color: 'currentColor', size: iconSizeBySize[size] }} />
    </span>
  );
};

export default IconTile;
